export default __webpack_public_path__ + "static/media/avatar-calendar_club_bot.f227f864.png";